import { render, staticRenderFns } from "./HomeFirstSection.vue?vue&type=template&id=163c165a&scoped=true"
import script from "./HomeFirstSection.vue?vue&type=script&lang=js"
export * from "./HomeFirstSection.vue?vue&type=script&lang=js"
import style0 from "./HomeFirstSection.vue?vue&type=style&index=0&id=163c165a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163c165a",
  null
  
)

export default component.exports